import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { useReactToPrint } from "react-to-print";

const YardWiseMisReport = ({ selectedDate }) => {
  const token = Cookies.get("token")?.replace(/"/g, "");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const [misReport, setMisReport] = useState([]);

  const getMisData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/yard-details/every-yard-details-report/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        date: selectedDate,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      setMisReport(result.data);
    } else {
      // handle error
    }
  };

  useEffect(() => {
    getMisData();
  }, [selectedDate]);

  // Get all unique product sizes from the data
  const productSizes = [
    ...new Set(
      misReport?.flatMap((factory) =>
        Object.values(factory["YARD DETAILS"]).flatMap(Object.keys)
      )
    ),
  ];

  const componentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    pageStyle: `
        @page {
          size: auto !important;
        }
        @media print {
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #ddd;
            border-spacing: 0;
            margin-bottom: 10px;
            transform: scale(0.9);
          }
          th, td {
            border: 1px solid #ddd;
            padding: 8px;
          }
        }`,
    documentTitle: "Yard Wise MIS Report",
  });

  return (
    <>
      <div className="btn_container d-flex justify-content-between flex-wrap">
        <button onClick={generatePDF} className="btn btn-primary mb-3">
          Generate PDF
        </button>
      </div>
      <div className="row" id="pdf-content">
        <div className="col-lg-12 grid-margin stretch-card">
          <div
            className="table-responsive table-bordered yard-wise-table"
            style={{ border: "0.05px solid lightGray" }}
          >
            <table className="table table-hover" ref={componentPDF}>
              <thead>
                <tr>
                  <th colSpan={productSizes.length + 2}>
                    DATE: {selectedDate}
                  </th>
                </tr>
                <tr style={{ textAlign: "center" }}>
                  <th>Factory Name</th>
                  <th>Yard</th>
                  {productSizes.map((size, index) => (
                    <th key={index}>{size}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {misReport?.map((factory, index) =>
                  Object.entries(factory["YARD DETAILS"]).map(
                    ([yardKey, sizes], yardIndex) => (
                      <tr key={`${index}-${yardKey}`}>
                        {yardIndex === 0 && (
                          <td
                            rowSpan={
                              Object.keys(factory["YARD DETAILS"]).length
                            }
                            style={{ fontWeight: "bold", maxWidth: "120px" }}
                          >
                            {factory["FACTORY NAME"]}
                          </td>
                        )}
                        <td>{yardKey}</td>
                        {productSizes?.map((size, sizeIndex) => (
                          <td key={`${index}-${yardKey}-${sizeIndex}`}>
                            {sizes[size] !== undefined ? sizes[size] : "NA"}
                          </td>
                        ))}
                      </tr>
                    )
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default YardWiseMisReport;
